import best_com from '../../assests/best_com.jpg';
import best_foreign from '../../assests/best_foreign.jpg';
import overall_best from '../../assests/overall_best.jpg';
import src_p from '../../assests/src.jpg';




import './honor.css';


const Honor=()=>{
    return(
        <>
        <div className='overall-div'>


      <div className='overall'>
        <div className='text-div'>
        <div className='img-div'>
            <img src={overall_best} alt='img' className='awards-img'/>

        </div>
        <div className='award-text-didv'>
        <h3 className='h3-honor'>Overall Best Graduating Student Award</h3>
    <div className='award-p-div'>
            <p className='award-p'>
            In August 2024, I was honored to receive the prestigious Overall Best Graduating Student Award at Dominion University College.
             This recognition reflects my dedication to academic excellence, leadership, and continuous learning throughout my studies. It stands as a testament to my commitment to pushing boundaries in my field and striving for success in all my endeavors.
             Along with the award, I also received a cash prize of 1,000 cedis.
            </p>
            </div>
            </div>
        </div>
        
        
        <div className='text-div'>
        <div className='img-div'>
            <img src={best_com} alt='img' className='awards-img'/>

        </div>
            <div className='award-text-didv'>
        <h3 className='h3-honor'>Best Computer Science Student Award</h3>
        <div className='award-p-div'>

            <p>
            This award was in recognition of my outstanding performance in the field of Computer Science. 
            It was a departmental award for graduating as the best student from the School of Science and Technology.
             This award acknowledges my competencies in both 
            the theoretical and technical aspects of Computer Science. It was presented with a cash prize of 500 Ghana Cedis.
            </p>
            </div>
            </div>
        </div>
        <div className='text-div'>
        <div className='img-div'>
            <img src={best_foreign} alt='img' className='awards-img'/>

        </div>
            <div className='award-text-didv'>
        <h3 className='h3-honor'>Best Foreign Student Award</h3>
        <div className='award-p-div'>


            <p>
            Dominion University College has a thriving community of international students,
             with individuals coming from Nigeria, Togo, Liberia, Ivory Coast, Angola, and more. 
             The Best Foreign Student award was presented in recognition of the academic contributions and the diversity that foreign students bring to the university. 
            This award also reflects my strong academic performance.
             In addition to the award, I received a cash prize of 500 Ghana Cedis.
            </p>
            </div>
            </div>
        </div>
        
        <div className='text-div'>
        <div className='img-div'>
            <img src={src_p} alt='img' className='awards-img'/>

        </div>
            <div className='award-text-didv'>
        <h3 className='h3-honor'>SRC Best Programmer Award</h3>
        <div className='award-p-div'>

            <p>
            The Best Programmer Award was presented by the Students' Representative Council during the Excellence Night Award and Dinner Night.
             This award recognized outstanding competence in programming skills.
             Dominion University students voted for the individual they believed demonstrated the highest level of proficiency in programming.
            </p>
            </div>
            </div>
        
        </div>
        </div>  
        </div>  


        
        </>
    )
}
export default Honor;